const trends = {
    number: "1/1",
    question: "What are the market trends in the next 5 years?",
    description: `Write core market trends that are expected to be vital to your business in the coming years. This will help your team focus
                                                    their attention around the right information and help you continuously stay relevant.`
}

export const questions = {
    trends: trends,
}

const trendsVideo = {
    url: "https://www.dropbox.com/scl/fi/kopqpb57vyote72b7y0x0/28-Market-Trends.mp4?rlkey=0woci39ktml7s9q5ayiafqo7n&raw=1"
}

export const videos = {
    trendsVideo: trendsVideo,
}